import React, { useEffect, useState } from "react";
import Layout from "../../components/UI/layout";
import ProductDetail from "../../components/Products/ProductDetail/ProductDetail";
import { getProductBySlug } from "../../services/Products/getProductBySlug";
import { getRecipeRelated } from "../../services/Products/getRecipeRelated";
import { getProductsRelated } from "../../services/Products/getProductsRelated";
import { SEO as Seo } from "../../components/UI/seo";
import canonicalMap from "../../utils/canonicalMap";

export async function getServerData({ params }) {
  const productSlug = params.slug;
  const detailProduct = await getProductBySlug(productSlug);

  const fullUrl = `https://peabody.com.ar/detalle/${productSlug}/`;
  const canonicalUrl = canonicalMap[fullUrl] || fullUrl;

  return {
    props: {
      product: detailProduct,
      canonicalUrl
    },
  };
}

const DetallePage = ({ serverData }) => {
  const { product } = serverData;

  const [productRelated, setProductRelated] = useState([]);
  const [recipeRelated, setRecipeRelated] = useState([]);

  useEffect(() => {
    getProductsRelated("argentina", product?.category, product?.product_code)
      .then((products) => {
        setProductRelated(products);
      })
      .catch((error) => {});

    getRecipeRelated(product?.category)
      .then((products) => {
        setRecipeRelated(products);
      })
      .catch((error) => {});
  }, []);

  return (
    <Layout>
      <ProductDetail
        product={product}
        productRelated={productRelated}
        recipeRelated={recipeRelated}
      />
    </Layout>
  );
};

export default DetallePage;

export const Head = ({ serverData }) => {

  if (!serverData?.product) {
    return null;  // Evitar renderizar Head si los datos no están listos
  }

  const { product, canonicalUrl } = serverData;
  const productMetaTitle = product.meta_title || `${product.name} - ${product.product_code}`
  const productMetaDescription = product.meta_description || product.description;

  return (
    <Seo
      title={!product ? "Producto no encontrado" : `${productMetaTitle} | Peabody Argentina`}
      description={!product? "Producto no encontrado" : productMetaDescription}
      imageUrl={product.images[0]}
    >
      <link rel="canonical" href={canonicalUrl} />
    </Seo>
  )
  
}
